import React, { memo, useId, useRef } from 'react';
import Draggable from 'react-draggable';

import Button from '../../helpers/Button';
import useFocusTrap from '../../helpers/Popup/useFocusTrap';
import { usePopupContext } from '../../../contexts/PopupContext';

import style from './style.module.css';

const DEFAULT_POSITION = {
  x: Math.floor((window.innerWidth - 600) / 2),
  y: 0,
};

/**
 * Popup for meeting details note.
 */
const MeetingDetailsNotePopup = props => {
  const popupContext = usePopupContext();

  const fromRegistry = props.popup?.get;
  const html = fromRegistry ? props.popup.getIn(['props', 'html']) : props.html;
  const isOpen = fromRegistry ? true : props.isOpen;
  const onClose = fromRegistry ? popupContext.closePopup : props.onClose;
  const dialogRef = useRef(null);
  const titleId = useId();

  useFocusTrap(dialogRef, isOpen);

  if (!isOpen) return null;

  const className = 'display-block move modal fade in';

  return (
    <>
      {props.isOpen && <div className="modal-backdrop fade in" style={{ zIndex: 1051 }} />}
      <div
        ref={dialogRef}
        aria-labelledby={titleId}
        aria-modal="true"
        className={className}
        id="meetingDetailsNotePopup"
        role="dialog"
        style={{ zIndex: 1052 }}
        tabIndex="-1"
      >
        <Draggable
          axis="both"
          bounds="parent"
          defaultPosition={DEFAULT_POSITION}
          handle=".handle-draggable"
          position={null}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header truncate-text handle-draggable">
                <button aria-label="Close" className="close" onClick={onClose} type="button">
                  <span aria-hidden="true">×</span>
                </button>
                <h4 className="modal-title" id={titleId}>
                  Detailed Notes
                </h4>
              </div>

              <div className="modal-body">
                <div className="row">
                  <div className="col-sm-12">
                    <iframe className={style.note} sandbox="" srcDoc={html} title="content" />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <Button onClick={onClose}>Close</Button>
              </div>
            </div>
          </div>
        </Draggable>
      </div>
    </>
  );
};

export default memo(MeetingDetailsNotePopup);
